<template>
  <CollapsibleLinks>
    <template #trigger="{ toggle }">
      <a
        class="font-bold text-primary hover:text-primary-dark text-lg"
        @click.stop.prevent="toggle"
        >{{ $t("branding.about") }}</a
      >
    </template>
    <div class="flex flex-col mb-3 gap-1 text-sm">
      <NuxtLink
        v-if="$branding.hasFeature(FEATURES.ABOUT_US)"
        :to="localePath({ name: 'aboutUs' }) + '#impressum'"
        class="text-white"
      >
        {{ $t("footer.aboutus") }}
      </NuxtLink>
      <FooterClickLink
        v-if="$branding.hasFeature(FEATURES.CAREER_PAGE)"
        :to="localePath({ name: 'careerPage' })"
        class="text-white"
        >{{ $t("footer.carreer") }}</FooterClickLink
      >
      <FooterClickLink
        v-if="$branding.hasFeature(FEATURES.BLOG)"
        :to="localePath({ name: 'blogLandingPage' })"
        class="text-white"
      >
        {{ $t("footer.blog") }}
      </FooterClickLink>
      <FooterClickLink
        v-if="$branding.hasFeature(FEATURES.QUESTIONS)"
        :to="localePath({ name: 'questionsPage' })"
        class="text-white"
        >{{ $t("footer.questions") }}</FooterClickLink
      >
      <a
        v-if="!$branding.isJoszaki"
        href="https://joszaki.hu"
        target="_blank"
        class="text-white"
      >
        {{ $t("footer.joszaki") }}
      </a>
      <a
        v-if="!$branding.isSuperprofikCz"
        href="https://superprofik.cz"
        target="_blank"
        class="text-white"
      >
        {{ $t("footer.superprofik") }}
      </a>
      <a
        v-if="!$branding.isBerufExperten"
        href="https://berufexperten.de"
        target="_blank"
        class="text-white"
      >
        {{ $t("footer.berufexperten") }}
      </a>
      <FooterClickLink
        v-if="$branding.hasFeature(FEATURES.INSPIRATION)"
        :to="localePath({ name: 'inspirationLandingPage' })"
        class="text-white"
        >{{ $t("footer.inspirations") }}</FooterClickLink
      >
    </div>
  </CollapsibleLinks>
</template>

<script>
import CollapsibleLinks from "./CollapsibleLinks.vue";
import FooterClickLink from "./FooterClickLink.vue";
import { FEATURES } from "~/config/pages/features.config";

export default {
  components: { CollapsibleLinks, FooterClickLink },
  setup() {
    return {
      FEATURES,
    };
  },
  computed: {
    notCzechOrGerman() {
      return !this.$branding.isSuperprofikCz && !this.$branding.isBerufExperten;
    },
  },
};
</script>
